import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GobiernoUser } from '../../interfaces/user.interface';
import {
    MotivoEstadoUsuario,
    UserServiceService,
} from '../../services/user-service.service';

@Component({
    selector: 'app-inactivar-usuario-modal',
    templateUrl: './inactivar-usuario-modal.component.html',
    styleUrls: ['./inactivar-usuario-modal.component.css'],
})
export class InactivarUsuarioModalComponent implements OnInit {
    @Input() public usuario!: GobiernoUser;

    public form!: FormGroup;
    public motivos: MotivoEstadoUsuario[] = [];
    public otroMotivoSeleccionado = false;
    public isLoading = true;
    public errorMessage = '';

    public get tipoAccion(): 'activación' | 'inactivación' {
        return this.usuario?.estado ? 'inactivación' : 'activación';
    }

    public constructor(
        public activeModal: NgbActiveModal,
        private fb: FormBuilder,
        private userService: UserServiceService
    ) {}

    public async ngOnInit(): Promise<void> {
        this.form = this.fb.group({
            motivo: ['', Validators.required],
            otroMotivo: [''],
        });

        try {
            const estado = this.usuario.estado ? 'inactivacion' : 'activacion';
            this.motivos =
                await this.userService.getMotivosActivacionInactivacionUsuario(
                    estado
                );
            this.motivos.sort((a, b) =>
                (a.nombre ?? '').localeCompare(b.nombre ?? '', 'es')
            );
        } catch {
            this.errorMessage = 'No se pudieron cargar los motivos.';
        } finally {
            this.isLoading = false;
        }

        this.form.get('motivo')?.valueChanges.subscribe((value) => {
            this.otroMotivoSeleccionado = value === 'otro';
            if (this.otroMotivoSeleccionado) {
                this.form
                    .get('otroMotivo')
                    ?.setValidators([
                        Validators.required,
                        Validators.minLength(3),
                    ]);
            } else {
                this.form.get('otroMotivo')?.clearValidators();
                this.form.get('otroMotivo')?.setValue('');
            }
            this.form.get('otroMotivo')?.updateValueAndValidity();
        });
    }

    public get nombreCompleto(): string {
        return `${this.usuario?.nombre ?? ''} ${this.usuario?.apellido ?? ''}`.trim();
    }

    public confirmar(): void {
        if (this.form.invalid) {
            return;
        }

        const { motivo, otroMotivo } = this.form.value;

        this.activeModal.close({
            motivo: motivo === 'otro' ? null : motivo,
            otroMotivo: otroMotivo || null,
        });
    }

    public cancelar(): void {
        this.activeModal.dismiss();
    }
}
